

















import Vue from "vue";
import { state } from "../data/state";
import { table_config } from "./table.config";
import TableRow from "./TableRow.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
export default Vue.extend({
  components: {
    VirtualTable,
  },
  setup() {
    const { sites_collection } = state;
    const {
      items,
      is_loading,
      load_more_items,
      has_no_results,
      has_more,
    } = sites_collection;
    return {
      items,
      is_loading,
      load_more_items,
      has_no_results,
      has_more,
      table_config,
      TableRow,
    };
  },
});
